<script>
export default {
  name: "chat-message",
  components: {},
  props: {
    messageData: Object,
  },
  data: function() {
    return {
      loadedMessages: [],
      loadedChunks: 0,
      lastChunk: 1,
    };
  },
  methods: {
    formatDate: function() {
      return formatDate(this.messageData.sentTime, true, true);
    },
  },
  computed: {
    currentUserId: function() {
      return this.$store.state.userId;
    },
    userRole: function() {
      return this.$store.state.role;
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
  },
};
</script>
<template>
  <div class="chat-message-wrapper" :class="currentUserId == messageData.createdByUserId && !messageData.systemNotification ? 'my-message' : 'other-message'">
    <div v-if="!messageData.systemNotification">
      <i class="user-name">{{ currentUserId == messageData.createdByUserId ? "You" : userRole == "OWN" ? "Host" : messageData.userName }}</i> <i class="message-time">{{ formatDate() }}</i>
      <br />
      <span v-html="messageData.content"></span>
    </div>
    <div v-else>
      <i class="user-name">System</i> <i class="message-time">{{ formatDate() }}</i>
      <br />
      <i v-html="messageData.content"></i>
    </div>
  </div>
</template>
<style>
.chat-message-wrapper {
  overflow-wrap: break-word;
}
#message-part-wrapper-mobile .chat-message-wrapper,
#message-part-wrapper-mobile .user-name {
  font-size: 11px;
}
.my-message {
  text-align: right;
}
.other-message {
}
.user-name {
  font-weight: bold;
  font-size: 14px;
}
.message-time {
  font-size: 12px;
}
</style>
